import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa6';
import { loginUser } from '../../store/auth/authActions';
import { errorToast, isValidEmail } from '../../utils';
import { useForm } from 'react-hook-form';

const LoginForm = () => {
    const { loading } = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const [showPassword, setShowPassword] = useState(false);
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const signinUser = async (data) => {
        dispatch(loginUser({
            email: data.email,
            password: data.password
        }))
        .unwrap()
        .catch((errorData) => {
            errorToast(errorData.error);
        });
    };

    return (
        <form onSubmit={handleSubmit(signinUser)} className="space-y-4">
            <div>
                <h1 className='mb-1 text-center text-nt-blue'>Sign In</h1>
                <p className='text-center text-sm text-nt-grey'>Welcome back. Enter your credentials to continue.</p>
            </div>
            <div className='mb-4'>
                <label className="block pb-1 text-[13px] font-medium text-primary-grey">Email</label>
                <div className="relative">
                    <input
                        className="nt-auth-input"
                        name="email"
                        placeholder="Enter your email"
                        id="email"
                        defaultValue={""}
                        {...register("email", {
                            required: "Email is required",
                            validate: (value) =>
                                isValidEmail(value) || "Please enter a valid email address",
                        })}
                        type="email"
                        required />
                </div>
                {errors.email && (
                    <span className="mt-1 block text-xs text-nt-red">{errors.email.message}</span>
                )}
            </div>
            <div>
                <div className="mb-1 flex items-center justify-between">
                    <label className="block text-[13px] font-medium text-primary-grey">Password</label>
                    <span className='text-[11px] text-slate-400'>At least 8 characters</span>
                </div>
                <div className="relative">
                    <input
                        className="nt-auth-input pr-11"
                        name="password"
                        placeholder="Enter your password"
                        id="password"
                        defaultValue={""}
                        {...register("password")}
                        type={showPassword ? "text" : "password"}
                        required />
                    <button
                        type="button"
                        className="nt-auth-eye-btn"
                        onClick={() => setShowPassword((v) => !v)}
                        aria-label={showPassword ? "Hide password" : "Show password"}
                        title={showPassword ? "Hide password" : "Show password"}
                    >
                        {showPassword ? <FaEyeSlash size={16} /> : <FaEye size={16} />}
                    </button>
                </div>
                <div className='min-h-[16px]'></div>
            </div>
            <button type="submit" className="w-full rounded-xl bg-nt-blue px-4 py-2.5 text-white transition hover:opacity-95 disabled:cursor-not-allowed disabled:opacity-70" disabled={loading}>
                {loading ? 'Loading...' : 'Login'}
            </button>
            <div className='border-t border-slate-100 pt-3 text-center text-sm'>
                <p className='mb-2'>
                    <Link to='/forgot' className="link">Forgot your password ?</Link>
                </p>
                <p>Don't have an account ? <Link to='/register' className="link">Register</Link>
                </p>
            </div>
        </form>)
}

export default LoginForm;